<div class="w-full relative">
  <div
    class="login-swiper-container overflow-hidden"
    [ngClass]="'login-swiper-container-' + timestamp"
  >
    <div class="swiper-wrapper flex">
      <div
        class="swiper-slide h-full"
        *ngFor="let slide of slidesStore; let i = index"
      >
        <img
          [src]="slide | imageSource"
          alt=""
          class="w-full lg:h-[500px] rounded-t-[5px] ltr:lg:rounded-l-[5px] ltr:lg:rounded-r-[0px] rtl:lg:rounded-r-[5px] rtl:lg:rounded-l-[0px]"
        />
      </div>
    </div>
    <div
      class="swiper-pagination"
      [ngClass]="'swiper-pagination-' + timestamp"
    ></div>
  </div>
</div>
